export enum EligibilityVerificationType {
  email = 'email',
  employee_identifier = 'employee_identifier',
  member_identifier = 'member_identifier',
  postal_dob_name = 'postal_dob_name',
  student_email = 'student_email',
  student_identifier = 'student_identifier',
}
